<template>
  <div
    @click="onClick(property._id)"
    class="h-[55px] px-2 flex items-center justify-between overflow-hidden border-b border-gray-100"
  >
    <div class="w-full overflow-hidden *:overflow-hidden *:whitespace-nowrap *:text-ellipsis *:leading-tight">
      <div class="text-sm font-medium text-gray-700">{{ property.name }}</div>
      <div class="text-xs font-medium text-gray-500">
        <span>{{ property.address }}</span>
        <span class="ml-1 text-xs tracking-wide" v-if="distanceStr">{{ distanceStr }}</span>
      </div>
    </div>
    <div class="text-gray-500 *:ml-2 flex h-full items-center">
      <i
        v-if="property.cellularIcon"
        class="text-base"
        :class="[property.cellularIcon.name, property.cellularIcon.color]"
      ></i>
      <i
        v-if="property.gatewayIcon"
        class="text-xl"
        :class="[property.gatewayIcon.name, property.gatewayIcon.color]"
      ></i>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useUser } from '@/stores/user.store';
import { createAnimation, useIonRouter } from '@ionic/vue';
import { PropertyRow } from 'common';
import { computed } from 'vue';

const props = defineProps<{
  property: PropertyRow;
}>();

const user = useUser();
const distanceStr = computed(() => {
  if (user.useMetric) {
    return props.property.distanceKm || props.property.distanceKm === 0
      ? `(${props.property.distanceKm} km)`
      : undefined;
  }
  return props.property.distanceMi || props.property.distanceMi === 0 ? `(${props.property.distanceMi} mi)` : undefined;
});
const router = useIonRouter();

function onClick(propertyId: string) {
  return router.push(`/property/${propertyId}`);
}
</script>

<style scoped>
.blue {
  @apply text-blue-500;
}
.gray {
  @apply text-gray-500;
}
</style>
